import { render } from "./FishLab.vue?vue&type=template&id=f7c273d2&scoped=true"
import script from "./FishLab.vue?vue&type=script&lang=js"
export * from "./FishLab.vue?vue&type=script&lang=js"

import "./FishLab.vue?vue&type=style&index=0&id=f7c273d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7c273d2"]])

export default __exports__